/**
 * A person's initials for an Avatar (R-050): the first letter of each of the
 * first two words, and in Arabic the letter after the article "ال". Arabic initials would JOIN into a word ("ل" + "ع" reads
 * "لع"), so a zero-width non-joiner keeps them apart as letters. No letters at
 * all gives "?", never an empty circle.
 */
const ARABIC = /[\u0600-\u06FF]/;

export function initialsOf(name: string | null | undefined): string {
  const firsts = (name ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => {
      const letters = Array.from(word);
      // Most Arabic family names begin with the article "ال": its alef would
      // make almost every family initial "ا", so the initial is the letter after it.
      return ARABIC.test(word) &&
        letters.length > 2 &&
        letters[0] === '\u0627' &&
        letters[1] === '\u0644'
        ? letters[2]
        : (letters[0] ?? '');
    });

  if (firsts.length === 0) return '?';

  return ARABIC.test(firsts.join(''))
    ? firsts.join('\u200C')
    : firsts.join('').toLocaleUpperCase('en');
}
